import { render } from "./CollectionFormView.vue?vue&type=template&id=52a08f7a&scoped=true"
import script from "./CollectionFormView.vue?vue&type=script&lang=js"
export * from "./CollectionFormView.vue?vue&type=script&lang=js"

import "./CollectionFormView.vue?vue&type=style&index=0&id=52a08f7a&lang=less&scoped=true"

import exportComponent from "/home/rampa/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52a08f7a"]])

export default __exports__